import React from 'react';

import {BulkActionTool} from 'src/components/bulk-tool';
import {
    bulkProductDischargeAccountEntitlements,
    getProductDischargeAccountEntitlementsProgress,
} from 'src/openapi/admin/apis/BulkProductDischargeAccountEntitlementsApi';
import {useAppDispatch} from 'src/store/hooks';

import {FlatButton} from '@pb/kit-component-button';
import {useShown} from '@pb/kit-hooks-use-shown';

import {
    TOOL_PROGRESS_LABEL,
    TOOL_STACK_OVERFLOW_MESSAGE,
    TOOL_TASK,
    TOOL_TITLE,
} from './constants';
import {UnassignProductAccountEntitlementsModal} from './unassign-product-account-entitlements.modal';
import {
    selectUnassignProductAccountEntitlementsBulkUuid,
    selectUnassignProductAccountEntitlementsTask,
    setBackgroundTask,
    setShown,
    setUuid,
} from './unassign-product-account-entitlements.slice';

import type {UpdateEntitlementsRelation} from 'src/openapi/admin/models/UpdateEntitlementsRelation';

type Props = {
    accountId: number,
    selectionKey: string,
    onDone: () => void,
};

export const UnassignProductAccountEntitlementsTool = ({selectionKey, onDone, accountId}: Props) => {
    const apiDispatch = useAppDispatch();
    const {shown, onClick, onClose} = useShown();

    return (
        <>
            <FlatButton onClick={onClick}>
                <b>{TOOL_TITLE}</b>
            </FlatButton>
            <BulkActionTool<UpdateEntitlementsRelation>
                shown={shown}
                onClose={onClose}

                toolTask={TOOL_TASK}
                toolName={TOOL_TITLE}
                progressLabel={TOOL_PROGRESS_LABEL}

                taskSelector={selectUnassignProductAccountEntitlementsTask}
                uuidSelector={selectUnassignProductAccountEntitlementsBulkUuid}

                setUuid={setUuid}
                setTask={setBackgroundTask}
                setResultShown={setShown}
                saveActionRequest={(updateEntitlementsRelation, options) => (
                    apiDispatch(bulkProductDischargeAccountEntitlements({...options, updateEntitlementsRelation}))
                )}
                getProgress={id => apiDispatch(getProductDischargeAccountEntitlementsProgress({id}))}

                stackOverflowMessage={TOOL_STACK_OVERFLOW_MESSAGE}
                onDone={onDone}>
                {({processAction, onCloseModal}) => (
                    <UnassignProductAccountEntitlementsModal
                        accountId={accountId}
                        selectionKey={selectionKey}
                        onCloseModal={onCloseModal}
                        processAction={processAction}
                    />
                )}
            </BulkActionTool>
        </>
    );
};
